import { createSelector } from '@reduxjs/toolkit';

export const selectAllEntries = (state) => state.entries.entries;

export const selectEntriesByClient = createSelector(
  [selectAllEntries, (_, clientID) => clientID],
  (entries, clientID) => entries.filter((entry) => entry.participants.some(({ id }) => id == clientID))
);

export const selectEntriesByCoach = createSelector([selectAllEntries, (_, coachID) => coachID], (entries, coachID) => {
  return entries.filter((entry) => entry.coaches.some(({ id }) => id == coachID));
});

export const selectEntriesByLocationAndDate = createSelector(
  [selectAllEntries, (state, locationID) => locationID, (state, locationID, date) => date],
  (entries, locationID, date) => entries.filter((entry) => entry.location.id === locationID && entry.date === date)
);
